import type { TIconProps } from "./types";

export const AvatarPlaceholder = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_390_55008)">
        <rect x={1} y={1} width={40} height={40} rx={20} fill="#F2EEEE" />
        <path
          d="M34.6896 33.1136H7.50781V18.3409C7.50781 10.8561 13.6139 4.75 21.0987 4.75C28.5836 4.75 34.6896 10.8561 34.6896 18.3409V33.1136Z"
          fill="#EBE95C"
        />
        <path
          opacity={0.4}
          d="M21.4924 4.94702C21.2954 4.94702 21.0984 4.94702 20.9014 4.94702C13.4166 4.94702 7.31055 11.0531 7.31055 18.5379V33.3107H8.2954V18.5379C8.49237 11.0531 14.2045 5.14399 21.4924 4.94702Z"
          fill="white"
        />
        <path
          opacity={0.2}
          d="M23.2654 4.94697C22.4775 4.75 21.8866 4.75 21.0987 4.75C13.6139 4.75 7.50781 10.8561 7.50781 18.3409V33.1136H11.8412V18.3409C11.6442 11.6439 16.5684 5.93182 23.2654 4.94697Z"
          fill="#CFCD51"
        />
        <path
          opacity={0.3}
          d="M21.0975 4.75C18.143 4.75 15.3854 5.73485 13.2188 7.31061C15.1884 6.12879 17.5521 5.53788 19.9157 5.53788C27.4006 5.53788 33.5066 11.6439 33.5066 19.1288V33.1136H34.6884V18.3409C34.6884 10.8561 28.5824 4.75 21.0975 4.75Z"
          fill="#FFFE99"
        />
        <path
          d="M21.0986 52.4166C14.7956 52.4166 8.88649 47.4923 7.90164 40.2045L6.12891 28.5833H36.2653L34.4925 40.2045C33.3107 47.2954 27.4016 52.4166 21.0986 52.4166Z"
          fill="#A0C3CF"
        />
        <path
          opacity={0.4}
          d="M30.9474 29.3713L29.3716 40.2047C28.3868 45.9168 24.2504 50.2501 19.3262 51.235C20.1141 51.4319 20.9019 51.4319 21.6898 51.4319C27.4019 51.4319 32.9171 46.7047 33.9019 40.2047L35.4777 29.3713H30.9474Z"
          fill="#EAFAFF"
        />
        <path
          opacity={0.3}
          d="M22.0834 51.4319C15.7804 51.4319 9.87133 46.5077 8.88649 39.2198L7.31072 28.3865H6.12891L7.90164 40.0077C9.08345 47.2956 14.7956 52.2198 21.0986 52.2198C24.2501 52.2198 27.4016 50.841 29.7653 48.6744C27.5986 50.4471 24.841 51.4319 22.0834 51.4319Z"
          fill="#EAFAFF"
        />
        <path
          opacity={0.3}
          d="M25.038 46.9016C18.735 46.9016 12.8259 41.9774 11.841 34.6895L10.8562 28.3865H6.12891L7.90164 40.0077C9.08345 47.2956 14.7956 52.2198 21.0986 52.2198C26.2198 52.2198 31.144 48.8713 33.3107 43.7501C30.9471 45.7198 27.9925 46.9016 25.038 46.9016Z"
          fill="#139BC6"
        />
        <g opacity={0.2}>
          <path
            d="M21.0983 32.3257C26.4165 32.3257 31.3407 32.9166 35.2801 33.7045L36.068 28.5833H5.93164L6.71951 33.7045C10.8559 32.7196 15.7801 32.3257 21.0983 32.3257Z"
            fill="#00587D"
          />
        </g>
        <path
          opacity={0.2}
          d="M34.6896 22.4773H7.50781V29.9621H34.6896V22.4773Z"
          fill="#8F8D38"
        />
        <path
          d="M35.4773 30.947H6.52273C5.53788 30.947 4.75 30.1591 4.75 29.1742V25.0379C4.75 24.053 5.53788 23.2651 6.52273 23.2651H35.4773C36.4621 23.2651 37.25 24.053 37.25 25.0379V29.1742C37.25 30.1591 36.4621 30.947 35.4773 30.947Z"
          fill="#ACB5EB"
        />
        <path
          opacity={0.1}
          d="M4.94727 29.5681C5.14424 30.356 5.73514 31.1439 6.52301 31.1439H35.4776C36.2654 31.1439 37.0533 30.553 37.0533 29.5681H4.94727Z"
          fill="#5C280E"
        />
        <path
          opacity={0.3}
          d="M5.14453 24.25H36.8567C36.4627 23.8561 36.0688 23.4622 35.4779 23.4622H6.52331C6.12937 23.4622 5.53847 23.6591 5.14453 24.25Z"
          fill="#606EC7"
        />
        <path
          opacity={0.3}
          d="M27.401 14.5984C27.401 18.1439 24.6434 20.9015 21.0979 20.9015C17.5525 20.9015 14.7949 18.1439 14.7949 14.5984C14.7949 11.053 17.5525 8.29541 21.0979 8.29541C24.4464 8.29541 27.401 11.25 27.401 14.5984Z"
          fill="#FFFFE6"
        />
        <path
          d="M27.401 14.2046C27.401 17.7501 24.6434 20.5077 21.0979 20.5077C17.5525 20.5077 14.7949 17.7501 14.7949 14.2046C14.7949 10.6592 17.5525 7.90161 21.0979 7.90161C24.4464 7.90161 27.401 10.6592 27.401 14.2046Z"
          fill="#FFFFE6"
        />
        <path
          opacity={0.1}
          d="M21.0994 7.90161C18.7358 7.90161 16.7661 9.08343 15.7812 11.0531C16.9631 9.87131 18.5388 9.2804 20.1146 9.2804C23.66 9.2804 26.4176 12.038 26.4176 15.5834C26.4176 16.7652 26.0237 17.7501 25.4328 18.7349C26.6146 17.5531 27.2055 15.9774 27.2055 14.4016C27.4025 10.6592 24.4479 7.90161 21.0994 7.90161Z"
          fill="#FF8A8A"
        />
        <path
          d="M21.0982 17.7501C23.0563 17.7501 24.6437 16.1627 24.6437 14.2046C24.6437 12.2465 23.0563 10.6592 21.0982 10.6592C19.1401 10.6592 17.5527 12.2465 17.5527 14.2046C17.5527 16.1627 19.1401 17.7501 21.0982 17.7501Z"
          fill="#5C3232"
        />
        <path
          opacity={0.7}
          d="M25.2355 11.447C25.2355 12.4318 24.4476 13.0227 23.6597 13.0227C22.6749 13.0227 22.084 12.2348 22.084 11.447C22.084 10.6591 22.8719 9.87121 23.6597 9.87121C24.4476 9.67424 25.2355 10.4621 25.2355 11.447Z"
          fill="white"
        />
        <path
          opacity={0.3}
          d="M32.1287 14.5985C32.1287 15.3864 31.5378 15.9773 30.7499 15.9773C29.962 15.9773 29.3711 15.3864 29.3711 14.5985C29.3711 13.8106 29.962 13.2197 30.7499 13.2197C31.5378 13.2197 32.1287 13.8106 32.1287 14.5985Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M11.0525 20.3107C11.0525 21.0986 10.4616 21.6895 9.6737 21.6895C8.88582 21.6895 8.29492 21.0986 8.29492 20.3107C8.29492 19.5228 8.88582 18.9319 9.6737 18.9319C10.4616 19.1289 11.0525 19.7198 11.0525 20.3107Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M31.1443 20.3107C31.1443 21.0986 30.5534 21.6895 29.7655 21.6895C28.9776 21.6895 28.3867 21.0986 28.3867 20.3107C28.3867 19.5228 28.9776 18.9319 29.7655 18.9319C30.5534 18.9319 31.1443 19.7198 31.1443 20.3107Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M12.4318 9.87118C12.4318 10.2651 12.0379 10.4621 11.8409 10.4621C11.6439 10.4621 11.25 10.0682 11.25 9.87118C11.25 9.47724 11.6439 9.28027 11.8409 9.28027C12.0379 9.28027 12.4318 9.67421 12.4318 9.87118Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M27.796 8.88641C28.1223 8.88641 28.3869 8.62185 28.3869 8.2955C28.3869 7.96915 28.1223 7.70459 27.796 7.70459C27.4696 7.70459 27.2051 7.96915 27.2051 8.2955C27.2051 8.62185 27.4696 8.88641 27.796 8.88641Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M11.6436 18.341C11.97 18.341 12.2345 18.0764 12.2345 17.7501C12.2345 17.4237 11.97 17.1592 11.6436 17.1592C11.3173 17.1592 11.0527 17.4237 11.0527 17.7501C11.0527 18.0764 11.3173 18.341 11.6436 18.341Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M15.3858 8.88641C15.7122 8.88641 15.9767 8.62185 15.9767 8.2955C15.9767 7.96915 15.7122 7.70459 15.3858 7.70459C15.0595 7.70459 14.7949 7.96915 14.7949 8.2955C14.7949 8.62185 15.0595 8.88641 15.3858 8.88641Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.3}
          d="M15.1896 21.6894C15.1896 22.0834 14.7957 22.2804 14.5987 22.2804C14.2048 22.2804 14.0078 21.8864 14.0078 21.6894C14.0078 21.2955 14.4017 21.0985 14.5987 21.0985C14.7957 20.9016 15.1896 21.2955 15.1896 21.6894Z"
          fill="#8F8D38"
        />
        <path
          opacity={0.6}
          d="M34.0976 37.053C33.9006 38.8258 33.1127 40.4015 31.9309 40.4015C30.9461 40.4015 30.1582 38.8258 30.1582 36.8561C30.3552 35.0833 31.143 33.5076 32.3249 33.5076C33.5067 33.7045 34.0976 35.2803 34.0976 37.053Z"
          fill="white"
        />
        <g
          style={{
            mixBlendMode: "color",
          }}
        >
          <rect x={1} y={1} width={40} height={40} fill="#043A76" />
        </g>
        <g
          style={{
            mixBlendMode: "overlay",
          }}
        >
          <rect x={1} y={1} width={40} height={40} fill="#3E4E61" />
        </g>
      </g>
      <rect
        x={0.95}
        y={0.95}
        width={40.1}
        height={40.1}
        rx={20.05}
        stroke="#D8ECFF"
        strokeWidth={0.1}
      />
      <defs>
        <clipPath id="clip0_390_55008">
          <rect x={1} y={1} width={40} height={40} rx={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
